import { Component } from '@angular/core';

@Component({
    selector: 'app-menu-calling-waiter',
    templateUrl: './menu-calling-waiter.component.html',
    styleUrls: ['./menu-calling-waiter.component.css'],
    standalone: false
})
export class MenuCallingWaiterComponent {

}
